import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

import { assignKennels, saveArea, reloadFacilities } from '../../actions/facilities/facilities.actions'
import { movePets } from '../../actions/pets/pets.actions'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import { PlayAreaDialog } from '../../components/Dialogs'
import KennelBlockDialogNew from '../../components/Dialogs/KennelBlockDialogNew'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'
import SelectPetDropdown from '../../components/Pets/SelectPetDropdown'
import { PlaygroupTable } from '../../components/Tables/PlaygroupTable'
import Loading from '../common/Loading'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	bottomBar: {
		position: 'fixed',
		bottom: 0,
		width: '100%',
		height: 60,
		background: '#FFF',
		borderTop: '1px solid #E5E5E5',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 20,
		zIndex: 10000,
		left: 0,
		boxShadow: '0px -3px 10px rgba(0,0,0,0.1)',
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35'
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		},
		[theme.breakpoints.up('md')]: {
			paddingLeft: 261
		}
	}
}))

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const Playgroups = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const query = useQuery()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const selectedPlaygroup = useSelector((state) => state.specific.facilities.selected_playgroup)

	const visits = useSelector((state) => state.specific.visits.visits)
	const staff = useSelector((state) => state.specific.facilities.staff)
	const pets = useSelector((state) => state.specific.visits.pets)
	const add_on_services = useSelector((state) => state.specific.visits.add_on_services)
	const loading = useSelector((state) => state.specific.facilities.loading)

	let originalDate = query.get('date')

	const [date, setDate] = useState(moment(originalDate || moment()).format('YYYY-MM-DD'))

	const [dialog, setDialog] = useState(false)
	const [kbShown, setKbShown] = useState(false)

	const [addOn, setAddOn] = useState(null)
	const [pet, setPet] = useState(null)
	const [selected, selectPet] = useState([])
	const [playAreaShown, setPlayShown] = useState(null)

	const params = useParams()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
		dispatch(reloadFacilities(false))
	}, [])

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(1, 'd').format('YYYY-MM-DD'))
		}
	}

	useEffect(() => {
		if (facility) {
			dispatch(getVisitsByFacilityId(facility, date))
		}
	}, [date, facility])

	useEffect(() => {
		if (params.playgroupId) selectPet([])
		dispatch({ type: 'SET_GROUP', payload: params.playgroupId })
	}, [params.playgroupId])

	const toggleSelect = () => {
		if (!selected.length) {
			let ids = getPets().map((p) => p._id)
			selectPet(ids)
		} else {
			selectPet([])
		}
	}

	const selectGroup = (group) => {
		let ourVisits = []
		visits.forEach((v) => {
			if (v.pet_status && v.status && v.status.id !== 7) {
				v.pet_status.forEach((stat, i) => {
					if (selected.includes(stat.pet_id)) ourVisits.push(v._id)
				})
			}
		})
		let payload = {
			pet_ids: selected,
			playgroup: group ? group._id : null,
			visit_ids: ourVisits
		}
		dispatch(movePets(payload))
		selectPet([])
	}

	const openDialog = (addOn, pet) => {
		setDialog(true)
		setAddOn(addOn)
		setPet(pet)
	}

	const getAddons = () => {
		return add_on_services.filter((a) => !a.date || a.date === date)
	}

	const setIsShown = (shown) => {
		setDialog(shown)
	}

	const getPets = () => {
		let pet_ids = []
		visits
			.filter((v) => v.status && v.status.id !== 7 && v.type !== 'grooming')
			.forEach((visit, i) => {
				visit.pet_status.forEach((status, i) => {
					if (status.playgroup === selectedPlaygroup) {
						const petIndex = pets.findIndex((p) => p._id === status.pet_id)
						if (petIndex > -1) {
							const petCubbies = visit.cubbies?.find((cub) => String(cub.pet_id) === String(status.pet_id)) || null
							pets[petIndex] = { ...pets[petIndex], cubbies: petCubbies }
						}
						pet_ids.push(status.pet_id)
					}
				})
			})

		const filtered = pet_ids.map((id) => pets.find((p) => p._id === id))
		return filtered
	}

	const getGroup = () => {
		if (!selectedPlaygroup || !facility) return null
		return facility.playgroups.find((g) => g._id === selectedPlaygroup)
	}

	const bottomBar = () => {
		if (kbShown || playAreaShown) return null
		let name = ``
		if (!selected.length) {
			name = 'far fa-square'
		} else {
			name = 'fa fa-minus-square checked'
		}
		return (
			<div className={classes.bottomBar}>
				<i className={name} style={{ fontSize: '16px' }} onClick={() => toggleSelect()} />
				<span className="whee">
					{selected.length} {`Pet${selected.length === 0 || selected.length > 1 ? 's' : ''}`} Selected
				</span>
				<SelectPetDropdown
					group={facility.playgroups.find((pg) => pg._id === selectedPlaygroup)}
					playgroups={facility.playgroups.filter(
						(g) => g.status === 'in use' && g._id !== selectedPlaygroup
					)}
					selectGroup={selectGroup}
					selected={selected}
					visits={visits.filter((v) => v.status && v.status.id !== 7 && v.type !== 'grooming')}
				/>
			</div>
		)
	}

	return (
		<div className={classes.root} key={selectedPlaygroup}>
			{facility && visits && selectedPlaygroup ? (
				<div className={classes.visitsTableContainer}>
					<PlaygroupTable
						group={facility.playgroups.find((g) => g._id === selectedPlaygroup)}
						areas={facility.areas}
						kennels={facility.kennels}
						pets={getPets()}
						date={date}
						visits={visits.filter((v) => v.status && v.status.id !== 7 && v.type !== 'grooming')}
						changeDate={changeDate}
						setDate={setDate}
						playgroups={facility.playgroups}
						selectPet={selectPet}
						selected={selected}
						setIsShown={(val, group) => setIsShown(val, group)}
						setDialogShown={(val) => setKbShown(val)}
						setPlayShown={(val) => setPlayShown(val)}
						staff={staff}
					/>
					{bottomBar()}

					<PlayAreaDialog
						isShown={playAreaShown}
						setIsShown={setPlayShown}
						staff={staff}
						facility={facility}
						selectedPlaygroup={getGroup()}
						saveArea={(group, area) => {
							dispatch(saveArea(facility._id, group, area))
						}}
					/>
				</div>
			) : (
				<Loading />
			)}
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default Playgroups
